function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "objectBoundingBox",
  x1: 4.639,
  x2: 4.626,
  y1: 6.951,
  y2: 6.951
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9166fe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c97aed"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m50.562 29.581c-15.5 26.652-44.026-6.9-47.313 26.5-1.185 43.233 67.602 30.919 85.787-5.03 9.494-18.767-13.342-64.689-38.474-21.47z",
  transform: "translate(-3.234 -11.611)"
});

var SvgShape07 = function SvgShape07(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 72,
    viewBox: "0 0 88 72",
    width: 88,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShape07, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shape_07.32644628.svg";
export { ForwardRef as ReactComponent };